module.exports = __webpack_public_path__ + "static/img/IMG_0432.2faf710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0432.jpg
// module id = jcXi
// module chunks = 12